/* Queries GraphQL para los combobox remotos (dominios, compañias, usuarios) */
import { gql } from "@apollo/client";

// Consulta dominios filtrada por tipo y padre (para dropdowns en cascada)
export const DOMAINSGENERAL = gql`
    query DOMAINSGENERAL(
      $search: String
      $first: Int
      $last: Int
      $type: String
      $parentid: String
    ) {
      domains(
        where: {
          name: { contains: $search }
          type: { equals: $type }
          parent_id: { equals: $parentid }
          deleted_at: { equals: null }
        }
        first: $first
        last: $last
        orderBy: { id: asc }
      ) {
        id
        name
      }
    }
  `;

// Compañias filtradas por where input
export const COMPANIES = gql`
  query Companies($where: companyWhereInput, $first: Int, $last: Int) {
    companies(
      where: $where
      first: $first
      last: $last
    ) {
      id
      name
      product
    }
  }
`;

// Busqueda de usuarios para el combobox
export const GET_USER = gql`
  query UsersCombobox(
    $first: Int
    $last: Int
    $where: userWhereInput!
  ) {
    userss(
      where: $where
      first: $first
      last: $last
    ) {
       id
       nickname
       names
       lastnames
       email
       extras
       company {
         id
         name
       }
     }
  }
`